export const LiteralConstant = {
  API_URL: 'API_URL'
}
